import React from 'react';

const URL_RE =
  /((?:https?:\/\/)?(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}(?::\d{2,5})?(?:[/?#][^\s<>"']*)?)/gi;


export function linkifyText(
  text: string,
  classes: { headerTitle: string; linkTitle: string },
) {
  const nodes: React.ReactNode[] = [];
  if (!text) return nodes;

  let lastIndex = 0;
  URL_RE.lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = URL_RE.exec(text)) !== null) {
    const raw = match[0];
    const start = match.index;
    const end = start + raw.length;

    // skip emails
    if (raw.includes('@')) continue;

    // push preceding text
    if (start > lastIndex) nodes.push(text.slice(lastIndex, start));

    // strip common trailing punctuation from the link only
    const trimmed = raw.replace(/[),.;:!?]+$/g, (punct) => {
      // keep the punctuation as text (not part of the link)
      nodes.push(punct);
      return '';
    });

    if (trimmed) {
      const href = trimmed.startsWith('http') ? trimmed : `https://${trimmed}`;
      nodes.push(
        <a
          key={`${start}-${href}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`${classes.headerTitle} ${classes.linkTitle}`}
          onClick={(e) => e.stopPropagation()}
        >
          {trimmed}
        </a>
      );
    }

    lastIndex = end;
  }

  // trailing text after last match
  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));

  return nodes;
}

export function hasAnyUrl(s: string) {
    URL_RE.lastIndex = 0;
    let m;
    while ((m = URL_RE.exec(s)) !== null) {
      if (!m[0].includes('@')) return true;
    }
    return false;
  }